import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { TokenService } from './services/storageService';
import ApiService from './services/apiServices';
import store from './store/store.js';
import VueMoment from 'vue-moment';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import VueSession from 'vue-session';

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

axios.interceptors.response.use((response) => {
  return response
}, function (error) {

  if (error.response.status === 401) {

    store.dispatch('destroyToken').then((response) => {
      Vue.prototype.$session.destroy();
      router.push({ name: 'login' });
    });
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

axios.interceptors.request.use(
  (config) => {
    
    const token = Vue.prototype.$session.get('jwt');
    
    //console.log("interceptor request >>> ", token)

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  error => Promise.reject(error),
);

if (TokenService.getToken()) {
}

const options = {
  persist: true,
};
Vue.use(VueSession, options);

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(VueSweetalert2);
new Vue({
  router,
  vuetify,
  store,
  moment,
  render: h => h(App)
}).$mount('#app')
